import { BaseComponent, Component, Prop, Ref, SimpleEvent, Watch } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * Product Landing
 */
@Component
export class ProductLanding extends ThemeComponent {
    @Ref mobileTabTriggers!: HTMLButtonElement[];
    @Ref mobileTabs!: HTMLDivElement[];
    @Ref stickyButtons!: HTMLDivElement[];

    protected activeTrigger: HTMLButtonElement|undefined|null = null;
    protected activeTab: HTMLDivElement|undefined|null = null;

    init() {

        this.activeTrigger = this.mobileTabTriggers.find(
            (tabTrigger) => tabTrigger.classList.contains('active-tab-trigger')
        );

        this.activeTab = this.mobileTabs.find((tab) => tab.classList.contains('active-tab'));

        for (const tabTrigger of this.mobileTabTriggers) {

            this.$listen(tabTrigger, 'click', (event) => {
                this.onTabClick(event);
            });
        }
    }

    onTabClick(event: Event) {

        const clickedElement = event.currentTarget as HTMLButtonElement;

        const tabId = clickedElement.dataset.id;

        const tabElement = this.mobileTabs.find((tab) => tab.dataset.id === tabId);

        if (!tabElement) {return;}

        if (this.activeTab) {
            this.activeTab.classList.remove('active-tab');
            this.activeTab = tabElement;
        }

        tabElement.classList.add('active-tab');

        if (this.activeTrigger) {
            this.activeTrigger.classList.remove('active-tab-trigger');
        }

        this.activeTrigger = clickedElement;

        this.activeTrigger.classList.add('active-tab-trigger');
    }
}
